import { render, staticRenderFns } from "./resourcePathList.vue?vue&type=template&id=f3b9d000&scoped=true&"
import script from "./resourcePathList.vue?vue&type=script&lang=js&"
export * from "./resourcePathList.vue?vue&type=script&lang=js&"
import style0 from "./resourcePathList.vue?vue&type=style&index=0&id=f3b9d000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b9d000",
  null
  
)

export default component.exports